// Picks the message to show the user, in Marathi, out of whatever the API returned.
//
// Order matters:
//   data.reason — per-call detail a service put in `data`. Already Marathi. It lives
//                 in `data` because responseHandler drops a `message` a service returns.
//   mr_message  — the response key's Marathi text, from the server's message.js.
//   fallback    — reached when `res` is undefined, which is the real network-failure
//                 path: axiosConfig's interceptor RESOLVES with error.response?.data,
//                 so an unreachable server never throws, it resolves with undefined.
//                 That is why the default talks about connectivity.
//
// res.message is deliberately never read — it is the English copy, kept for logs and
// the English-UI super-admin screens.
export const apiMessage = (res, fallback = "सर्व्हरशी संपर्क होत नाही — कृपया पुन्हा प्रयत्न करा") =>
  res?.data?.reason || res?.mr_message || fallback;

export default apiMessage;
